export default "__VITE_PUBLIC_ASSET__ae594f12__"